import React, { Component } from 'react'
import styled from 'styled-components'
import UserMenu from './UserMenu'
import { Brand } from './Brand'

const NavBar = styled.div`
  display: grid;
  z-index: 100;
  align-items: stretch;
  grid-template-columns: auto auto;
  min-height: 80px;
  max-height: 100px;
  position: relative;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
`

const NavLeft = styled.div`
  display: grid;
  align-items: center;
  justify-items: start;
`

const NavRight = styled.div`
  display: grid;
  align-items: center;
  justify-items: end;
`

class AppNav extends Component {
  render() {
    return (
      <NavBar>
        <NavLeft>
          <Brand />
        </NavLeft>
        <NavRight>
          <UserMenu />
        </NavRight>
      </NavBar>
    )
  }
}

export default AppNav
